@if (!loading) {
  <div class="welcome-page">

    <img class="welcome-logo" src="./assets/logoTransparent.png" alt="Truth Engine" />

    <div class="welcome-card">
      @if (multipleCompanies) {
        <div class="welcome-sub">{{currentComp ? 'Company' : 'Choose a company to continue'}}</div>
        <mat-form-field appearance="outline" class="welcome-select">
          <input matInput
            [formControl]="companySearchCtrl"
            [matAutocomplete]="compAuto"
            placeholder="Start typing company name...">
          @if (companySearchCtrl.value) {
            <button mat-icon-button matSuffix (click)="clearCompanySearch()" type="button">
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-autocomplete #compAuto="matAutocomplete"
            [displayWith]="displayCompanyName"
            (optionSelected)="onCompanySelected($event)">
            @for (comp of filteredCompanies; track comp) {
              <mat-option [value]="comp">
                {{comp.companyName}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      } @else {
        <div class="welcome-sub">Company</div>
        <div class="welcome-single-comp">{{currentComp?.companyName}}</div>
      }

      <div class="welcome-divider"></div>

      <div class="welcome-user-row">
        <div class="welcome-user-id">
          @if (currentUser) {
            <div class="username">{{currentUser.fullName}}</div>
          } @else {
            <div class="username">User</div>
          }
          <div class="welcome-email">{{currentUserEmail}}</div>
        </div>
        <button mat-stroked-button (click)="signOut()" class="welcome-signout">
          Sign out
        </button>
      </div>
    </div>

    @if (appVersion) {
      <div class="welcome-meta">
        version&nbsp;<span class="semi-bold">{{appVersion}}</span>
      </div>
    }
  </div>
}

@if (loading) {
  <app-spinner></app-spinner>
}
